import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://nevskifit.com';

// This is a client-rendered SPA (no SSR/prerendering), so social crawlers
// (Facebook, Twitter, Slack, ...) never execute JS and only ever see the
// static Open Graph tags in public/index.html, regardless of route. Only
// title/description/canonical are managed here since those are what
// Googlebot's JS-rendered pass and search snippets actually use per page.
function SEO({ title, description, path = '/' }) {
  const fullTitle = `${title} | NevskiFit`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}

export default SEO;
